import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record';
import { RatingService } from '../rating.service';
import { UtilsService } from '../utils.service';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-rating-summary',
  templateUrl: './rating-summary.component.html',
  styleUrls: ['./rating-summary.component.css']
})
export class RatingSummaryComponent implements OnInit {
  @Input() dbRecord: DbRecord;
  @Input() ratingType: string;
  private _adminConfirmSet = new Set<string>();

  constructor(
    private rs: RatingService,
    private utils: UtilsService,
    private users: UsersService,
  ) { }

  ngOnInit() {

  }

  displayName(email) {
    return;
  }

  adminDeleteConfirmed(email) {
    this._adminConfirmSet.delete(email);
    let obs = this.dbRecord.project.adminRatingDelete(
      this.dbRecord,
      this.ratingType,
      email);
  }


  adminDelete(email) {
    if (!this._adminConfirmSet.delete(email)) {
      this._adminConfirmSet.add(email);
    }
  }

  isAdminDeleteMode(email) {
    return this._adminConfirmSet.has(email);
  }

  isMy(email) {
    return email === this.utils.email;
  }

  get isAbstractRated() {
    return this.isAbstract || this.rs.isAbstractRated(this.dbRecord);
  }

  get isAbstract() {
    return this.ratingType === 'abstract';
  }

  get isFulltext() {
    return this.ratingType === 'fulltext';
  }

  get usersLs() {
    let s = this.dbRecord.project.ratingSummary(this.dbRecord, this.ratingType);
    if (!s) {
      return [];
    }
    let ls = [];


    s.forEach((tpl, email) => {
      const values = [];
      tpl[1].forEach(x => values.push(this.rs.label(x)));
      ls.push({
        email: email, state: tpl[0],
        values: values.join('; ')
      });
    });
    return ls;
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/rating-summary/rating-summary.component.ts